import { cn } from "../lib/utils";

const SCRIPT_SRC = "/brand/freddy-logo-script.png";
const SEAL_SRC = "/brand/freddy-logo-seal-symbol.png";
const SYMBOL_SRC = "/brand/freddy-logo-symbol.png";

// F speech-bubble mark — official PNG
export function FreddyMark({ size = 28, className, alt = "Freddy" }) {
  return (
    <img
      src={SYMBOL_SRC}
      alt={alt}
      width={size}
      height={size}
      className={cn("inline-block select-none", className)}
      style={{ width: size, height: size, objectFit: "contain" }}
      draggable={false}
    />
  );
}

// White F-mark variant (uses CSS filter to invert non-red pixels - actually we just
// keep the same image; the symbol art works on dark navy because the bubble is red
// and the F is white, which already provides contrast on either background).
export function FreddyMarkWhite({ size = 28, className }) {
  return <FreddyMark size={size} className={className} />;
}

// Scripted "Freddy" wordmark image (navy script + red F-bubble) + co-branding tag
export function FreddyWordmark({ className, showTagline = true, height = 32, variant = "navy" }) {
  // For the navy sidebar header we need the wordmark legible on dark.
  // The artwork is navy script. On white headers, render as-is.
  // On navy backgrounds, swap to a white version via CSS filter.
  const filterStyle =
    variant === "white"
      ? { filter: "brightness(0) invert(1)" }
      : undefined;

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img
        src={SCRIPT_SRC}
        alt="Freddy"
        style={{ height, width: "auto", objectFit: "contain", ...filterStyle }}
        className="select-none"
        draggable={false}
      />
      {showTagline && variant !== "white" && (
        <span className="hidden md:inline text-[11px] text-navy/60 font-medium leading-tight pl-2 border-l border-navy/10">
          for Ourisman
          <br />
          Automotive Group
        </span>
      )}
    </div>
  );
}

// Circular FREDDY MEDIA seal — official PNG
export function FreddySeal({ size = 96, className }) {
  return (
    <img
      src={SEAL_SRC}
      alt="Freddy Media"
      width={size}
      height={size}
      className={cn("inline-block select-none", className)}
      style={{ width: size, height: size, objectFit: "contain" }}
      draggable={false}
    />
  );
}
